import { Outlet } from "react-router";

import NotFound from "legacy/containers/NotFoundPage";
import { PageLoading } from "shared/components/utils/PageLoading";
import { useOpenFeatureFlag } from "shared/hooks";

interface FeatureBoundaryProps {
  flag: string;
}

const FeatureBoundary = ({ flag }: FeatureBoundaryProps) => {
  const { loading, value } = useOpenFeatureFlag(flag);

  if (loading) {
    return <PageLoading />;
  }

  if (value !== true) {
    return <NotFound />;
  }

  return <Outlet />;
};

export { FeatureBoundary };
